/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-07-06 16:23:08
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-18 10:35:57
 */
import permissionState from './modules/permission/state';
import userState from './modules/user/state';
import systemState from './modules/system/state';
import teamState from './modules/team/state';

const vuex_dy_category = JSON.parse(localStorage.getItem('vuex_dy_category') || '[]');
const vuex_ks_category = JSON.parse(localStorage.getItem('vuex_ks_category') || '[]');
const vuex_sp_category = JSON.parse(localStorage.getItem('vuex_sp_category') || '[]');
const vuex_hostAppKey = localStorage.getItem('vuex_hostAppKey');
const vuex_shareId = sessionStorage.getItem('vuex_shareId');
const vuex_shopId = sessionStorage.getItem('vuex_shopId');
const state = {
	...permissionState,
	...userState,
	...systemState,
	...teamState,
	vuex_hostAppKey: vuex_hostAppKey || '', // 独立化部署标识
	vuex_shareId: vuex_shareId || '', //分享ID
	vuex_shopId: vuex_shopId || '', //商品ID
	vuex_baseInfo: {}, // 当前应用的基本配置信息
	vuex_dy_category: vuex_dy_category, // 抖音行业大类
	vuex_ks_category: vuex_ks_category, // 快手行业大类
	vuex_sp_category: vuex_sp_category, // 视频号行业大类
	vuex_alert_msg: false,
	updateInfo: {},
};

export default state;
